import util from '../util'

let controller = 'v1/ListaPositivaExclusao'

export default Object.assign({}, util.GetCrud(controller, null), {
  Listar: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + "/Listar", dto)
  },
  GerarExcelRelatorioListaPositivaExclusao: function (dto) {
    return util.Axios.GetAll(controller + '/lista-positiva-exclusao-xlsx', dto)
  }
})